<template>
  <span class="p-icon-point">
    <span v-if="isDefaultIcon" class="p-icon-point__default">
      <IconPointDefault
        :icon-size="iconSize"
        :bg-color="bgColor"
        :icon-color="iconColor"
        :border-color="iconColor"
      />
    </span>
    <span
      v-else-if="isCustomIcon"
      :style="iconStyleObject"
      class="p-icon-point__custom"
    >
      <img :src="getPoint()" alt />
    </span>
  </span>
</template>

<script lang="ts">
import IconPointDefault from "@/common/components/icons/IconPointDefault.vue";
import { Options, Vue } from 'vue-class-component';
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
import store from "@/general/store";
import AuthApi from "@/general/api/authApi";

@Options({
  props: {
	iconSize: { type: [Number, Boolean], default: false },
	iconSpSize: { type: [Number, Boolean], default: false },
	bgColor: { type: String, default: "#ffffff" },
	iconColor: { type: [String, Boolean], default: false },
	borderColor: { type: [String, Boolean], default: false },
	iconType: { type: String, default: "custom" },
	point_logo: 	{
	    type: String,
	    default: false
	  }
  },
  components: {
    IconPointDefault
  },
  store: store
})
export default class IconPoint extends Vue {
  iconSize!:
    | number
    | boolean;
  iconSpSize!:
    | number
    | boolean;
  bgColor!: string | boolean;
  iconColor!:
    | string
    | boolean;
  borderColor!:
    | string
    | boolean;
  iconType!: string;

  point_logo!: string;
  point_logo2 = "";

  isSp = globals.isSpScreenWidth;
  colorCode: string | undefined = "";
  point = commons.point;

  //#59042対応によりセッション情報からpoint_logoを取得するように修正
  async created(){
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.point_logo2 = ic_session.pointLogo;
    })
    .catch(() => {
      this.point_logo2 = "";
    });
  }

  getPoint() {
    if (this.point_logo) {
      return this.point_logo;
    }

    //#59042対応によりセッション情報からpoint_logoを取得するように修正
    //if (commons?.OrgPageSpecific?.point_logo) {
    //  return commons?.OrgPageSpecific?.point_logo;
    //}
    //TODO define default point logo.
    //return commons?.OrgPageSpecific?.point_logo;

    return this.point_logo2;
  }

  get iconStyleObject() {
    const { iconSize, iconSpSize, isSp } = this;

    const spIconSize = iconSpSize || iconSize;
    const resultIconSize = isSp ? spIconSize : iconSize;

    const iconStyleObject = {
      width: `${resultIconSize}px`,
      height: `${resultIconSize}px`
    };

    return iconStyleObject;
  }

  get internalIconColor() {
    const colorCode = commons?.OrgPageSpecific?.page_color;

    return {
      iconColor: this.iconColor === false ? colorCode : this.iconColor,
      borderColor: this.borderColor === false ? colorCode : this.borderColor
    };
  }

  get isDefaultIcon() {
    return this.iconType === "default";
  }

  get isCustomIcon() {
    //const point.icon = commons.OrgPageSpecific?.point_logo;
    const iconType = "custom";
    return true;
    //return point.icon !== false && point.icon !== "" && iconType === "custom";
  }
}
</script>

<style lang="scss" scoped>
.p-icon-point {
  display: block;

  &__default {
    display: flex;
  }

  &__custom {
    border-radius: 50%;
    overflow: hidden;
    display: flex;

    img {
      display: block;
    }
  }
}
</style>
